import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../../util/theme';

const CtaBarFormNotes = styled.div`
  padding: 0 25px;

  flex-basis: 50%;

  textarea {
    background-color: transparent;

    color: ${getColor('white')};
    font-family: 'Roboto', sans-serif;

    border: 0;
    border-bottom: 2px solid ${getColor('complimentaryBlue')};

    height: 100px;
    width: 100%;

    margin: 24px 0;

    &::placeholder {
      color: ${getColor('white')};
    }

    &:hover,
    &:focus {
      border-bottom: 2px solid ${getColor('accentGreen')};
    }
  }
`;

export default CtaBarFormNotes;
